"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardTitle_vue_1 = __importDefault(require("./CardTitle.vue"));
const CardResourceCounter_vue_1 = __importDefault(require("./CardResourceCounter.vue"));
const CardCost_vue_1 = __importDefault(require("./CardCost.vue"));
const CardExtraContent_vue_1 = __importDefault(require("./CardExtraContent.vue"));
const CardExpansion_vue_1 = __importDefault(require("./CardExpansion.vue"));
const CardTags_vue_1 = __importDefault(require("./CardTags.vue"));
const CardVictoryPoints_vue_1 = __importDefault(require("./CardVictoryPoints.vue"));
const CardContent_vue_1 = __importDefault(require("./CardContent.vue"));
const CardHelp_vue_1 = __importDefault(require("./CardHelp.vue"));
const CardType_1 = require("@/common/cards/CardType");
const Tag_1 = require("@/common/cards/Tag");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const CardResource_1 = require("@/common/CardResource");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
exports.default = (0, vue_1.defineComponent)({
    name: 'Card',
    components: {
        CardTitle: CardTitle_vue_1.default,
        CardHelp: CardHelp_vue_1.default,
        CardResourceCounter: CardResourceCounter_vue_1.default,
        CardCost: CardCost_vue_1.default,
        CardExtraContent: CardExtraContent_vue_1.default,
        CardExpansion: CardExpansion_vue_1.default,
        CardTags: CardTags_vue_1.default,
        CardContent: CardContent_vue_1.default,
        CardVictoryPoints: CardVictoryPoints_vue_1.default,
    },
    props: {
        card: {
            type: Object,
            required: true,
        },
        actionUsed: {
            type: Boolean,
            required: false,
            default: false,
        },
        robotCard: {
            type: Object,
            required: false,
        },
        cubeColor: {
            type: String,
            required: false,
            default: 'neutral',
        },
        autoTall: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        const cardName = this.card.name;
        const card = (0, ClientCardManifest_1.getCardOrThrow)(cardName);
        return {
            cardInstance: card,
            hovering: false,
            customHeight: 0,
        };
    },
    computed: {
        cardExpansion() {
            return this.cardInstance.module;
        },
        cardCompatibility() {
            return this.cardInstance.compatibility;
        },
        isResourceCard() {
            if (this.cardInstance.resourceType !== undefined) {
                return true;
            }
            else {
                return false;
            }
        },
        tags() {
            const type = this.cardType;
            const tags = [...this.cardInstance.tags || []];
            tags.forEach((tag, idx) => {
                if (tag === Tag_1.Tag.CLONE && this.card.cloneTag !== undefined) {
                    tags[idx] = this.card.cloneTag;
                }
            });
            if (type === CardType_1.CardType.EVENT) {
                tags.push(Tag_1.Tag.EVENT);
            }
            return tags;
        },
        cost() {
            return this.isProjectCard ? this.cardInstance.cost : undefined;
        },
        reducedCost() {
            return this.isProjectCard ? this.card.calculatedCost : undefined;
        },
        cardType() {
            return this.cardInstance.type;
        },
        cardClasses() {
            const classes = [];
            classes.push('card-' + this.card.name.toLowerCase().replaceAll(' ', '-'));
            if (this.card.isDisabled) {
                classes.push('card-unavailable');
            }
            else if (!(0, PreferencesManager_1.getPreferences)().experimental_ui && this.actionUsed) {
                classes.push('card-unavailable');
            }
            if (this.isStandardProject) {
                classes.push('card-standard-project');
            }
            const learnerModeOff = !(0, PreferencesManager_1.getPreferences)().learner_mode;
            if (learnerModeOff && this.isStandardProject && this.card.isDisabled) {
                classes.push('card-hide');
            }
            return classes.join(' ');
        },
        cardMetadata() {
            return this.cardInstance.metadata;
        },
        cardRequirements() {
            return this.cardInstance.requirements;
        },
        resourceAmount() {
            return this.card.resources || this.robotCard?.resources || 0;
        },
        isCorporationCard() {
            return this.cardType === CardType_1.CardType.CORPORATION;
        },
        isProjectCard() {
            const type = this.cardType;
            return type === CardType_1.CardType.AUTOMATED || type === CardType_1.CardType.ACTIVE || type === CardType_1.CardType.EVENT;
        },
        isStandardProject() {
            return this.cardType === CardType_1.CardType.STANDARD_PROJECT || this.cardType === CardType_1.CardType.STANDARD_ACTION;
        },
        hasResourceType() {
            return this.card.isSelfReplicatingRobotsCard === true || this.cardInstance.resourceType !== undefined || this.robotCard !== undefined;
        },
        resourceType() {
            if (this.robotCard !== undefined || this.card.isSelfReplicatingRobotsCard === true)
                return CardResource_1.CardResource.RESOURCE_CUBE;
            return this.cardInstance.resourceType ?? CardResource_1.CardResource.RESOURCE_CUBE;
        },
        bottomPadding() {
            if (this.cardMetadata.victoryPoints !== undefined) {
                return 'long';
            }
            if (this.hasResourceType) {
                return 'short';
            }
            return '';
        },
        hasHelp() {
            return this.hovering && this.cardInstance.metadata.hasExternalHelp === true;
        },
        typedRefs() {
            return this.$refs;
        },
        showPlayerCube() {
            return (0, PreferencesManager_1.getPreferences)().experimental_ui && this.actionUsed;
        },
        playerCubeClass() {
            return `board-cube board-cube--${this.cubeColor}`;
        },
    },
    methods: {
        makeFullSize() {
            if (!this.isProjectCard) {
                return;
            }
            if (this.customHeight === 0) {
                this.customHeight = (this.typedRefs.content.$el).scrollHeight;
                if (this.customHeight === 0) {
                    return;
                }
            }
            const content = this.typedRefs.content.$el;
            if (content.scrollHeight <= 236) {
                return;
            }
            this.typedRefs.container.style.height = (this.customHeight + 90) + 'px';
            content.style.height = this.customHeight + 'px';
        },
        unmakeFullSize() {
            if (!this.isProjectCard) {
                return;
            }
            if (this.customHeight === 0) {
                return;
            }
            const content = this.typedRefs.content.$el;
            this.typedRefs.container.style.removeProperty('height');
            content.style.removeProperty('height');
        },
    },
    mounted() {
        this.customHeight = (this.typedRefs.content.$el).scrollHeight;
    },
    beforeUpdate() {
        if (this.autoTall === true) {
            this.makeFullSize();
        }
        else {
            this.unmakeFullSize();
        }
    },
    watch: {
        hovering(val) {
            if (this.autoTall || !(0, PreferencesManager_1.getPreferences)().experimental_ui) {
                return;
            }
            if (val) {
                this.makeFullSize();
            }
            else {
                this.unmakeFullSize();
            }
        },
    },
});
